export default __webpack_public_path__ + "static/tw-90a299a9032e667ee79c285aa7942dda.svg";